import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getAdminAccountList } from '../../actions/adminActions';
import { APP_ROOT_URL } from '../../actions/urlTypes';

import Users from '../../components/admin/user';
import AddUserIcon from '../../components/admin/shared/AddUserIcon';

class UserManagement extends Component {
  static propTypes = {
    children: PropTypes.node,
    getAdminAccountList: PropTypes.func,
    adminAccounts: PropTypes.instanceOf(Object),
  }

  static defaultProps = {
    adminAccounts: {},
  };

  state = {

  }

  UNSAFE_componentWillMount() {
    if (!this.props.adminAccounts.data) {
      const sq = {
        all: 'true',
      };
      this.props.getAdminAccountList(sq);
    }
  }

  render() {
    const { children } = this.props;
    if (children) {
      return (
        <div>
          { children }
        </div>
      );
    }
    return (
      <div className="admin-body usersearch-body">
        <div className="admin--page-header">
          <Link className="button button-add-user" to={`${APP_ROOT_URL}/admin/users/add`}>
            <AddUserIcon /> Add User
          </Link>
        </div>
        <Users />
      </div>
    );
  }
}

const mapStateToProps = ({ admin }) => ({
  adminAccounts: admin.adminAccounts,
});

const mapDispatchToProps = dispatch => {
  return {
    getAdminAccountList: bindActionCreators(getAdminAccountList, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);

